<template>
  <div v-if="loaded" class="h-full">
    <div v-if="share && share.isActive && currentProject" class="h-full">
      <div v-if="currentProject">
        <div class="fixed top-0 left-0 w-full z-50 bg-primary">
          <div class="flex max-w-1000 mx-auto p-20 justify-between w-full">
            <LogoModule />

            <div class="flex items-center">
              <ButtonModule
                v-if="isWriteMode"
                :text="isMobile ? '' : 'lock'"
                class="text-app-color mr-20 px-0 py-0"
                :class="currentProject.isLocked ? 'opacity-100' : 'opacity-50'"
                :prefix="currentProject.isLocked ? 'icon-lock-close' : 'icon-lock-open'"
                @click="lock"
              />

              <More />
            </div>
          </div>
        </div>
        <Workspace
          v-if="currentProject"
          :key="currentProject.id"
          class="mt-60 md:mt-75 bg-white"
          :project="currentProject"
          :projects="[]"
          :allow-edit="!currentProject.isLocked && isWriteMode"
          :is-shared="true"
        />
      </div>
    </div>
    <div v-else class="flex h-full w-full">
      <div class="m-auto">
        <p class="text-22 md:text-30 font-bold">This share link is no longer active</p>

        <p class="text-16 mb-15 md:mb-40">Check with the person who shared this with you if they have access to the shared document.</p>

        <ButtonModule
          text="Back to Home"
          class="text-blue-main text-18"
          prefix="icon-keyboard-arrow-left text-13"
          @click="$router.push({ name: 'Books' })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import Workspace from '@/components/workspace/Workspace'
import More from '@/components/header/More'
import LogoModule from '@/components/shared/LogoModule'

import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import { projectService } from '@/services'

export default {
  components: { Workspace, ButtonModule, More, LogoModule },

  data () {
    return {
      loaded: false
    }
  },

  computed: {
    ...mapGetters(['isMobile']),
    ...mapState({
      share: state => state.project.share,
      currentProject: state => state.project.currentProject
    }),

    isWriteMode () {
      return this.share?.mode === 'write'
    }
  },

  created () {
    this.loading(true)

    projectService.getShare(this.$route.params.shareId)
      .then(res => {
        this.setShare(res.data)

        if (res.data.isActive) {
          projectService.getSharedProject(res.data.projectId, this.$route.params.shareId)
            .then(project => {
              this.loaded = true
              document.title = project.data.title + ' | Hello Ivy'
              this.setCurrentProject(project.data)
              this.resetSettings()
              this.getSizeOfSharedProject(project.data.id)
              this.loading(false)
            })
            .catch(() => (this.loaded = true))
        } else {
          this.loaded = true
          this.loading(false)
        }
      })
  },

  methods: {
    ...mapActions(['getSizeOfSharedProject']),

    ...mapMutations(['setCurrentProject', 'resetSettings', 'loading', 'setNotification', 'setShare']),

    lock () {
      this.loading(true)
      projectService.editSharedProject(
        this.share.projectId,
        this.$route.params.shareId,
        {
          title: this.currentProject.title,
          isLocked: !this.currentProject.isLocked
        }
      ).then(() => {
        this.setCurrentProject({
          ...this.currentProject,
          isLocked: !this.currentProject.isLocked
        })
        this.loading(false)
      })
    }
  }
}
</script>
